import styled from 'styled-components';

import Table from 'components/ui/Table';

import { colours } from 'themes/default';

export const FareWrapper = styled.div`
  display: block;
  overflow-x: auto;
`;

export const FareConditionsInactiveMessage = styled.div`
  margin-bottom: 20px;
  color: red;
`;

export const FareContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 8px;
  align-items: ${({ shouldBeCentered }) => (shouldBeCentered ? 'center' : 'flex-start')};
`;

export const FareDescription = styled.span`
  display: inline-flex;
  word-wrap: break-word;
  color: ${({ color }) => color};
`;

export const StyledTable = styled(Table)`
  display: block;
  max-width: -moz-fit-content;
  max-width: fit-content;
  margin: 0 auto;
  overflow-x: auto;
  white-space: nowrap;
  position: relative;
  border-collapse: separate;
  border-spacing: 0;

  th,
  td {
    min-width: 150px;
  }

  tr th:first-of-type {
    position: sticky;
    left: 0;
    top: auto;
    background: ${colours.Greyscale.CharcoalGrey};
  }

  tr td:first-of-type {
    position: sticky;
    left: 0;
    top: auto;
  }

  tr th,
  tr td {
    border-right: 1px solid white;
  }
`;
